import { useMutation } from "@tanstack/react-query";
import { createPaymentOrder } from "../actions/createPaymentOrder";

export const useCreatePaymentOrder = () => {
  const mutation = useMutation({
    mutationFn: createPaymentOrder,
  });

  return {
    createPaymentOrder: mutation.mutateAsync,
    isCreatingPaymentOrder: mutation.isPending,
    error: mutation.error,
    isError: mutation.isError,
  };
};
